<template>
<div class="upgrade-page">
  <h1 class="page-title">
    <span>Upgrades</span>
  </h1>


<b-card-group deck>
  <b-card title="Create Upgrade Schedule Rule" v-if="$base.isAllowed('sentinelUpgrade')">
    <b-card-text>
      <b-input-group prepend="Circuit" class="mb-3">
        <b-form-select
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          v-model="selectedCircuit"
          :options="circuits"
          v-if="can_render_circuit_dropdown"
          id="select-circuit">
            <template v-slot:first>
              <option :value="null">Select...</option>
            </template>
          </b-form-select>
      </b-input-group>
      <b-input-group prepend="Version" class="mb-3">
        <b-form-select class="mb-2 mr-sm-2 mb-sm-0 "
          v-model="selectVersionsSelected"
          :options="versions"
          id="select-version">
        </b-form-select>
      </b-input-group>
      <b-button variant="primary" v-b-modal.confirm-upgrade
        :disabled="selectedCircuit==null" @click="prepareDeviceUpgradeModal">Next</b-button>
      <b-modal id="confirm-upgrade" title="Confirm Upgrade"
        header-bg-variant="dark" size="lg" header-text-variant="light" @ok="sendUpgradeRequest">
        <b-table small striped hover
          :items="devices"
          :fields="selectedDevicesFields">

        </b-table>
        <p>Confirm upgrade <b-badge>{{ devices.length }}</b-badge> devices to version <b-badge>{{ selectVersionsSelected }}</b-badge></p>
      </b-modal>
    </b-card-text>
  </b-card>
  
<b-card title="Device Versions">
    <b-card-text>
      <vc-donut :sections="deviceVersions"
        :size="100"
        :thickness="30"
        :has-legend="true"
        :total="devicesTotal"
        legend-placement="right"
        style="justify-content: left">
      </vc-donut>
    </b-card-text>
  </b-card>
</b-card-group>

<b-card class="mt-5" no-body>
  <b-tabs card>
    <b-tab title="Upgrade Circuit Rules" active>
      <template v-slot:title>
        <h6>Upgrade Circuit Rules: <b-badge>{{ circuitUpgradeRules.length }}</b-badge></h6>
      </template>
      <ResponsiveTable
          v-if="circuitUpgradeRulesWithNames && circuitUpgradeRulesWithNames.length"
          :items="circuitUpgradeRulesWithNames"
          :fields="upgradeCircuitRuleFields"
          sort-by="upgrade_rule"
          sort-direction="desc"
      >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.serial, fromDevicePage: true }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(actions)="row">
            <b-button
              :id="'delete-upgrade-ruel-'+ row.item.circuit_uuid"
              class="mr-2"
              v-if="$base.isAllowed('sentinelUpgrade')"
              @click="openCancelModal('circuitRule', row.item)"
              variant="primary"
              size="sm">
            Cancel
            </b-button>
           <b-button
              :id="'edit-upgrade-ruel-'+ row.item.circuit_uuid"
              v-if="$base.isAllowed('sentinelUpgrade')"
              variant="primary"
              @click="openEditModal('circuitRule', row.item)"
              size="sm">
            Edit
            </b-button>
        </template>
        </ResponsiveTable>
    </b-tab>
    <b-tab title="Upgrade Device Rules">
      <template v-slot:title>
        <h6>Upgrade Device Rules: <b-badge>{{ deviceUpgradeRules.length }}</b-badge></h6>
      </template>
      <ResponsiveTable
          v-if="deviceUpgradeRules && deviceUpgradeRules.length"
          :items="deviceUpgradeRules"
          :fields="upgradeDeviceRuleFields"
          sort-by="upgrade_rule"
          sort-direction="desc"
      >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.serial, fromDevicePage: true }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(actions)="row">
            <b-button
              :id="'delete-upgrade-ruel-'+ row.item.circuit_uuid"
              class="mr-2"
              v-if="$base.isAllowed('sentinelUpgrade')"
              @click="openCancelModal('deviceRule', row.item)"
              variant="primary"
              size="sm">
            Cancel
            </b-button>
            <b-button
              :id="'edit-upgrade-ruel-'+ row.item.circuit_uuid"
              v-if="$base.isAllowed('sentinelUpgrade')"
              variant="primary"
              @click="openEditModal('deviceRule', row.item)"
              size="sm">
            Edit
            </b-button>
        </template>
        </ResponsiveTable>
    </b-tab>
    <b-tab title="Ongoing upgrades" @click="updateDeviceUpgrades">
      <template v-slot:title>
        <h6>Ongoing upgrades: <b-badge>{{ deviceUpgrades.length }}</b-badge></h6>
      </template>
      <ResponsiveTable
          v-if="deviceUpgrades && deviceUpgrades.length"
          :items="deviceUpgrades"
          :fields="ongoingUpgradeFields"
          :searchable_fields="ongoingUpgradeSearchableFields"
          sort-by="product_serial_num"
          sort-direction="desc"
      >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.serial, fromDevicePage: true }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
              v-if="$base.isAllowed('sentinelUpgrade')"
              class="cancelButton"
              id="cancel_button"
              @click="openCancelModal('ongoingDeviceUpgrade', row.item)"
              variant="primary"
              size="sm">
            Cancel
          </b-button>
        </template>
          <template v-slot:cell(status)="row">
            <span class="glyphicon status-icon" v-b-tooltip title="Downloading"
              v-bind:class="{
                grey: row.item.status == 'PENDING',
                blue: row.item.status == 'DOWNLOADING',
                green: ['VERIFYING', 'INSTALLING'].includes(row.item.status),
                'glyphicon-ok-circle': row.item.status != 'DOWNLOADING',
                'glyphicon-time': row.item.status == 'DOWNLOADING'
              }">
            </span>
            <span class="glyphicon status-icon" v-b-tooltip title="Verifying"
              v-bind:class="{
                grey: ['PENDING', 'DOWNLOADING'].includes(row.item.status),
                blue: row.item.status == 'VERIFYING',
                green: row.item.status == 'INSTALLING',
                'glyphicon-ok-circle': row.item.status != 'VERIFYING',
                'glyphicon-time': row.item.status == 'VERIFYING'
              }">
            </span>
            <span class="glyphicon status-icon" v-b-tooltip title="Installing"
              v-bind:class="{
                grey: ['PENDING', 'DOWNLOADING', 'VERIFYING'].includes(row.item.status),
                blue: row.item.status == 'INSTALLING',
                'glyphicon-ok-circle': row.item.status != 'INSTALLING',
                'glyphicon-time': row.item.status == 'INSTALLING'
              }">
            </span> {{ row.item.status }}
            <a class="fas fa-exclamation-triangle text-warning"
            v-if="row.item.issues"
            v-b-modal.upgrade-issues
            @click="prepareUpgradeIssuesModal(row.item.issues, row.item.product_serial_num)"
            >
            </a>
          </template>
        </ResponsiveTable>
    </b-tab>
    <b-tab title="Upgrade Log" lazy @click="updateUpgradeLog">
      <template v-slot:title>
        <h6>Upgrade Log</h6>
      </template>

      <ResponsiveTable
          :items="upgradeLog"
          :fields="upgradeLogFields"
          :searchable_fields="upgradeLogSearchableFields"
          :sortBy="'time'"
          :sortDirection="'desc'"
      >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.serial }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(to_version)="row">
         <span class="glyphicon status-icon glyphicon-ok-circle green" />{{ row.item.to_version }}
        </template>
      </ResponsiveTable>
    </b-tab>
  </b-tabs>
</b-card>

  <b-modal ref="upgrade-issues" id="upgrade-issues" title="Device upgrade issues"
    header-bg-variant="dark" size="lg" header-text-variant="light" ok-only>
    <h3>{{ upgradeIssuesDevice }}</h3>
    <b-table striped hover :items="upgradeIssues" :fields="['msg', 'data']" thead-class="d-none">
    <template v-slot:cell(data)="row">
      <vue-json-pretty :data="row.item.data">
      </vue-json-pretty>
    </template>
    </b-table>
  </b-modal>

  <b-modal
    id="cancel-upgrade"
    :title="cancelModalConfig.title"
    header-bg-variant="dark"
    size="lg"
    header-text-variant="light"
    ok-only>
    
    <h4 class="card-title">{{ cancelModalConfig.bodyText }}</h4>
    
    <template #modal-footer>
      <b-button size="sm" variant="danger" @click="$bvModal.hide('cancel-upgrade')">
        No
      </b-button>
      <b-button size="sm" variant="success" @click="executeCanceUpgradeAction()">
        Yes
      </b-button>
    </template>
  </b-modal>

   <b-modal
      ref="edit-upgrade"
      id="edit-upgrade"
      :title="editModalConfig.title"
      header-bg-variant="dark"
      size="lg"
      header-text-variant="light"
      ok-only>
    
    <h4 class="card-title">Edit Upgrade Rule for {{ editModalConfig.context.circuit_name || editModalConfig.context.product_serial_num }}</h4>
     
     <b-input-group prepend="Version" class="mb-3">
        <b-form-select class="mb-2 mr-sm-2 mb-sm-0 "
          v-model="editVersionsSelected" 
          :options="versions"
          id="select-version-edit">
        </b-form-select>
      </b-input-group>
      
    <template #modal-footer>
      <b-button size="sm" variant="danger" @click="$bvModal.hide('edit-upgrade')">
        No
      </b-button>
      <b-button size="sm" variant="success" @click="executeEditUpgradeAction()">
        Yes
      </b-button>
    </template>
  </b-modal>

</div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapState
} from 'vuex';
import VueJsonPretty from 'vue-json-pretty';
import {upgradesService} from "@/_services";
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import ResponsiveTable from "@/components/ResponsiveTable/ResponsiveTable";
import {circuitService} from "@/_services";
import {isEmpty} from "lodash";


export default {
  name: 'Upgrades',
  components: {
    ResponsiveTable,
    VueJsonPretty
  },

  data() {
    return {
      selectVersionsSelected: '',
      upgradeCircuitRuleFields: [
        {
          key: 'circuit_name',
          label: 'CIRCUIT',
          sortable: true,
          sortDirection: 'asc',
        },  
        {
          key: 'upgrade_rule',
          label: 'UPGRADE RULE',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'upgrade_rule_creation_timestamp',
          label: 'TIMESTAMP',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter
        },
        {
          key: 'actions',
          label: 'ACTIONS',
        }
      ],
      upgradeDeviceRuleFields: [
        {
          key: 'device_serial',
          label: 'DEVICE SERIAL',
          sortable: true,
          sortDirection: 'asc',
        },  
        {
          key: 'upgrade_rule',
          label: 'UPGRADE RULE',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'upgrade_rule_creation_timestamp',
          label: 'TIMESTAMP',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter
        },
        {
          key: 'actions',
          label: 'ACTIONS',
        }
      ],
      ongoingUpgradeFields: [{
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'current_version',
          label: 'CURRENT VERSION',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'target_version',
          label: 'TARGET VERSION',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'status',
          label: 'STATUS',
          sortable: true,
          sortDirection: 'asc',
        },
       {
          key: 'actions',
          label: 'ACTIONS',
        }
      ],
      ongoingUpgradeSearchableFields: [
          "product_serial_num",
          "current_version",
          "target_version",
          "status"
      ],
      selectedCircuit: null,
      selectedDevicesFields: [{
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
        },
        {
          key: 'software_version',
          label: 'CURRENT VERSION',
        }
      ],
      upgradeIssues: [],
      upgradeIssuesDevice: '',
      upgradeLog: [],
      upgradeLogFields: [{
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'time',
          label: 'TIME',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter
        },
        {
          key: 'from_version',
          label: 'FROM VERSION',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'to_version',
          label: 'TO VERSION',
          sortable: true,
          sortDirection: 'asc',
        }
      ],
      upgradeLogSearchableFields: [
          "product_serial_num",
          "from_version",
          "to_version"
      ],
      deviceVersions: [],
      devicesTotal: 999999,
      immediate: false,
      circuit: {
        "uuid": "",
        "name": "",
        "bounds": null,
        "circuit_type": "11kV",
        "circuit_geojson": {
          "type": "GeometryCollection",
          "geometries": []
        },
        "poles":[],
        "is_active": null,
        "circuit_primary": null,
        "circuit_reference": null,
      },
      circuits: [],
      can_render_circuit_dropdown: false,
      deviceUpgradeToCancel: {
        "product_serial_num": null,
        "target_version": null,
        "hex_serial": null
      },
      circuitUpgradeToCancel: {
        "circuit_uuid": null,
        "circuit_name": null
      },
      editModalConfig: {
        title: 'Edit Upgrade Rule',
        action: null,
        context: {},
        ruleType: null,
      },
      editVersionsSelected: null,
      cancelModalConfig: {
        title: 'Cancel Upgrade',
        bodyText: '',
        action: null,
        context: {}, 
      },
      circuitNameMap:{}
    }
  },


  computed: {
    ...mapGetters('upgrades', ['versions', 'deviceUpgrades', 'circuitUpgradeRules', 'deviceUpgradeRules']),
    ...mapGetters('device', ['devices']),
    ...mapState("layout", {
      hideInactiveCircuits: state => state.hideInactiveCircuits
    }),
    circuitUpgradeRulesWithNames() {
      const rules = this.circuitUpgradeRules;
      const nameMap = this.circuitNameMap;

      if (!rules.length || !Object.keys(nameMap).length) {
        return rules;
      }

      return rules.map(rule => {
        const circuitName = nameMap[rule.circuit_uuid] || 'Unknown Circuit';
        
        return {
          ...rule,
          circuit_name: circuitName, 
        };
      });
    },
  },
  methods: {
    ...mapActions('upgrades', [
        'findAllVersions', 'updatePackagesFromArtifactory', 'requestUpgradeCircuit', 'findAllDeviceUpgrades','findAllDeviceUpgradeRules', 'findAllCircuitUpgradeRules', 'deleteCircuitUpgradeRuleLocally', 'editCircuitUpgradeRuleLocally']),
    ...mapActions('alert', ['success', 'error']),
    ...mapActions('device', ['findByCircuit']),
    refreshVersions() {
      return this.updatePackagesFromArtifactory().then(() => {
          this.findAllVersions().then( () =>  {
            if (!isEmpty(this.versions)) {
              this.selectVersionsSelected = this.versions[0];
            }
          });
        })
    },
    executeCanceUpgradeAction() {
      if (this.cancelModalConfig.action) {
          this.cancelModalConfig.action(); 
      }
    },
    executeEditUpgradeAction() {
      if (this.editModalConfig.action) {
          this.editModalConfig.action();
      }
    },
    cancelOngoingDeviceUpgrade() {
      const device = this.cancelModalConfig.context;
      upgradesService.deleteDeviceUpgrade(device.serial, device.target_version)
      .then(() => {
        this.success("Successfully canceled upgrade of " + this.deviceUpgradeToCancel.serial);
        this.updateDeviceUpgrades();
      })
      .catch(() => {
          this.error("Error canceling upgrade of device " + this.deviceUpgradeToCancel.serial);
      }).finally(() => {
          this.$bvModal.hide('cancel-upgrade')
      })
    },
    cancelCircuitUpgradeRule() {
      const rule = this.cancelModalConfig.context;
      const circuitName = rule.circuit_name || rule.circuit_uuid;
      upgradesService.cancelCircuitUpgradeRule(rule.circuit_uuid)
      .then(() => {
        this.success("Successfully canceled upgrade of " + circuitName);
        this.deleteCircuitUpgradeRuleLocally(rule.circuit_uuid); 
      })
      .catch(() => {
          this.error("Error canceling upgrade of circuit " + circuitName);
      }).finally(() => {
          this.$bvModal.hide('cancel-upgrade')
      })
    },
    cancelDeviceUpgradeRule() {
      const rule = this.cancelModalConfig.context;
      upgradesService.deleteDeviceUpgradeRule(rule.device_serial)
      .then(() => {
        this.success("Successfully canceled upgrade of " + rule.device_serial);
        this.findAllDeviceUpgradeRules();
      })
      .catch(() => {
          this.error("Error canceling upgrade of circuit " + rule.device_serial);
      }).finally(() => {
          this.$bvModal.hide('cancel-upgrade')
      })
    },
    editCircuitUpgradeRule() {
      const originalRule = this.editModalConfig.context;
      const newVersion = this.editVersionsSelected;
      
      const updatedRule = {
          circuit_uuid: originalRule.circuit_uuid,
          upgrade_package_name: newVersion,
      };
      
      upgradesService.editUpgradeRuleForCircuit(updatedRule)
      .then(() => {
          this.success("Successfully edited upgrade rule for " + originalRule.circuit_name);
          this.editCircuitUpgradeRuleLocally({
              circuit_uuid: updatedRule.circuit_uuid,
              upgrade_rule: updatedRule.upgrade_package_name 
          });
      })
      .catch(() => {
          this.error("Error editing upgrade rule for circuit " + originalRule.circuit_name);
      }).finally(() => {
          this.$bvModal.hide('edit-upgrade')
      })
    },
    editDeviceUpgradeRule() {
      const originalRule = this.editModalConfig.context;
      const newVersion = this.editVersionsSelected;
      
      const updatedRule = {
          device_serial: originalRule.device_serial,
          upgrade_package_name: newVersion,
      };
      
      upgradesService.editUpgradeRuleForDevice(updatedRule)
      .then(() => {
          this.success("Successfully edited upgrade rule for " + originalRule.device_serial);
         this.findAllDeviceUpgradeRules();
      })
      .catch(() => {
          this.error("Error editing upgrade rule for device " + originalRule.device_serial);
      }).finally(() => {
          this.$bvModal.hide('edit-upgrade')
      })
    },
    openCancelModal(actionType, item) {
      let actionFunction;
      let bodyText;
      
      if (actionType === 'circuitRule') {
          actionFunction = this.cancelCircuitUpgradeRule;
          bodyText = `Are you sure you want to cancel the Circuit Upgrade Rule for circuit ${item.circuit_name}?`;
      } else if (actionType === 'deviceRule') {
          actionFunction = this.cancelDeviceUpgradeRule; 
          bodyText = `Are you sure you want to cancel the Device Upgrade Rule for device ${item.product_serial_num}?`;
      } else if (actionType === 'ongoingDeviceUpgrade') {
          actionFunction = this.cancelOngoingDeviceUpgrade;
          bodyText = `Are you sure you want to cancel the Ongoing Upgrade for device ${item.product_serial_num}?`;
      } else {
          return;
      }
      
      this.cancelModalConfig.bodyText = bodyText;
      this.cancelModalConfig.action = actionFunction;
      this.cancelModalConfig.context = item;
      
      this.$bvModal.show('cancel-upgrade');
    },
    openEditModal(ruleType, item) {
      let actionFunction;
      let title;
      
      if (ruleType === 'circuitRule') {
          actionFunction = this.editCircuitUpgradeRule;
          title = 'Edit Circuit Upgrade Rule';
      } 
      else if (ruleType === 'deviceRule') {
          actionFunction = this.editDeviceUpgradeRule;
          title = 'Edit Device Upgrade Rule';
      }
      else {
          return;
      }
      
      this.editModalConfig.title = title;
      this.editModalConfig.action = actionFunction;
      this.editModalConfig.context = item;
      
      this.editVersionsSelected = item.upgrade_rule; 
      
      this.$bvModal.show('edit-upgrade');
    },
    selectCircuits() {
      return circuitService.getAllCircuits().then(
        circuits => {
          this.circuits = circuits.map(function (item) {
            return {value: item.uuid, text: item.name}
          })
          const nameMap = {};
          circuits.forEach(item => {
              nameMap[item.uuid] = item.name;
          });
          this.circuitNameMap = nameMap;
          
          this.can_render_circuit_dropdown = true
        }
      )
    },
    sendUpgradeRequest() {
      const selectedCircuit = this.selectedCircuit;
      const versionSeleced = this.selectVersionsSelected;
      this.requestUpgradeCircuit({selectedCircuit, versionSeleced})
      .then(() => {
        this.success("Successfully scheduled devices upgrade to version " + this.selectVersionsSelected);
        this.findAllDeviceUpgrades();
        this.findAllDeviceUpgradeRules();
        this.findAllCircuitUpgradeRules();
      })
      .catch(() => {
          this.error("Error sending upgrade request.");
      });
    },
    prepareDeviceUpgradeModal() {
      this.findByCircuit(this.selectedCircuit);
    },
    prepareUpgradeIssuesModal(issues, device) {
      this.upgradeIssues = issues;
      this.upgradeIssuesDevice = device;
    },
    updateUpgradeLog() {
      upgradesService.getUpgradeLog()
        .then(response => {
          this.upgradeLog = response.data.upgrade_log;
          this.upgradeLog.forEach(function(obj){
            obj.actions = null
          })
        })
        .catch(() => {
          this.error('Error getting Upgrade Log');
        });
    },
    updareDeviceVersions() {
      upgradesService.getDevicesVersions()
        .then(response => {
          this.deviceVersions = response.data.version_count.map(function(item) {
            return {
              label: "("+item.count+") "+item.version,
              value: item.count
            };
          });
          this.devicesTotal = response.data.total;
        })
        .catch(() => {
          this.error('Error getting Devices versions count');
        });
    },
    updateDeviceUpgrades() {
      this.findAllDeviceUpgrades();
      this.findAllDeviceUpgradeRules();
      this.updareDeviceVersions();
    }
  },
  mounted() {
    this.selectCircuits()
    this.findAllVersions().then(() => {
      this.refreshVersions();
    });
    this.updateDeviceUpgrades();
    this.findAllCircuitUpgradeRules();
    this.findAllCircuitUpgradeRules();
  }

};
</script>

<style src="./Upgrades.scss" lang="scss" />
